import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import Paper from '@material-ui/core/Paper';

import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './TechnicalRepresentativeScreenStyles';
import TechnicalRepresentativeForm from 'app/components/TechnicalRepresentativeForm';
import TechnicalRepresentativeTableContainer from 'app/containers/TechnicalRepresentativeTableContainer';

import { useDispatch } from 'react-redux';
import { technicalRepresentativeClear } from 'app/actions/TechnicalRepresentativeActions';

export default function TechnicalRepresentativeScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [filter, setFilter] = useState([]);
    const [visibleForm, isVisibleForm] = useState(false)
    const [idResponsible, setIdResponsible] = useState(0);
    const [nameResponsible, setNameResponsible] = useState('');
    const [FiltroNombre, setFiltroNombre] = useState([]);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    useEffect(() => {
        return () => {
            dispatch(technicalRepresentativeClear());
        }
    }, []);
    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCatalog={true} header=' Representantes Técnicos' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Catálogos
                        </Link>
                        <TextEvents
                            text="Catálogo de Representantes Técnicos"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Paper className={classes.rootPaper}>
                    <TechnicalRepresentativeForm idResponsible={idResponsible} setIdResponsible={setIdResponsible} nameResponsible={nameResponsible} setNameResponsible={setNameResponsible} visibleForm={visibleForm} isVisibleForm={isVisibleForm} filter={filter} setFilter={setFilter} pagination={pagination} sorter={sorter} formData={formData} setFormData={setFormData} FiltroNombre={FiltroNombre} setFiltroNombre={setFiltroNombre} />
                    <div style={styles.baseVerticalMargin}>
                        <TechnicalRepresentativeTableContainer setIdResponsible={setIdResponsible} setNameResponsible={setNameResponsible} isVisibleForm={isVisibleForm} classes={classes} filter={filter} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination} formData={formData} FiltroNombre={FiltroNombre} setFiltroNombre={setFiltroNombre}>
                            {(params) => {
                                return (
                                    <div>
                                        <Table
                                            loading={params.isLoading}
                                            rowKey={item => String(item.idResponsible)}
                                            columns={params.cols}
                                            dataSource={params.technicalRepresentative}
                                            onChange={params.handleTableChange}
                                            pagination={pagination}
                                            scroll={{ x: 'min-content', y: (height - 395) }}
                                            size={"small"}
                                        // scroll={{ y: 700, x: "min-content" }}

                                        />
                                    </div>
                                )
                            }}
                        </TechnicalRepresentativeTableContainer>
                    </div>
                </Paper>


            </div>
        </div>
    )
}